<template>
   <div id="intro-page">
    <div class="intro-page-container">
      <div class="main-copy-area background">
        <h2 class="blind">온라인 가입신청서 작성 초기화면</h2>
        <p class="flex">
          <span class="lg-u-plus">LG U<sup>+</sup></span
          ><span class="title">공식 온라인 가입채널에</span>
        </p>
        <p class="welcome-message">오신 것을 환영합니다.</p>

        <div class="separator-small" />

        <div class="column-layout intro-copy">
            저희 <strong>LG U<sup>+</sup></strong>는 고객님의 개인정보보호 및 편리한 가입을 위해<br/> 공식 온라인 가입시스템을 지원하고 있습니다.<br/><br/>
            온라입 가입채널 이용을 위해서는 본인인증절차를 거친 후 가입이 가능하므로<br/>공인증서, 핸드폰, 신용카드 중 한가지를 미리 준비하여 주시기 바랍니다.<br/><br/>
            이후 화면에서 조회되는 대리점은 <strong>LG U<sup>+</sup></strong> 본사가 보증하는 <br/>공식 온라인 대리점이므로 안심하시고 가입하셔도 됩니다.
        </div>

        <div class="separator-small" />

        <div class="intro-selection">
          <div class="button-container">
            <button
              type="button"
              class="new-registration ml0"
              @click="goToRegistrationStep1"
              v-bind:disabled="changeDisabled" :class="{ disabled:changeDisabled }"
            >
              서비스 신규 신청
            </button>
            
             <button
              type="button"
              class="in-progress-registration ml10" 
              @click="goToExistingRegistration"
              v-bind:disabled="changeDisabled" :class="{ disabled:changeDisabled }"
            >
              서비스 추가 신청
            </button>
            <!-- <button type='button' class='in-progress-registration' @click='goToExistingRegistration'>진행중 신청서</button>         -->
          </div>
        </div>
      </div>
    </div>
    <div class="column-layout main-sub-area">
      <p class="text-info-title">주의 사항</p>

      <ul class="notice-text-list">
            <li class="notice-text">
              ※ 주소창에 onsalehome.uplus.co.kr이 표시되어 있는지 확인하여 주시기 바랍니다.
            </li>
            <li class="notice-text">
              ※ 다음 단계의 가입자정보 입력화면에 본인인증 절차가 있는지 확인하여 주시기 바랍니다.
            </li>
            <li class="notice-text">
              ※ 주소가 틀리거나 본인인증 절차가 없을 경우 피싱 사이트일 가능성이 있으므로 입력을 중지하시고 1644-7000번으로 해당사이트를 신고하여 주시기 바랍니다.
            </li>
      </ul>
    </div>
    <v-dialog />
  </div>
</template>

<script>

export default {
  name: 'OnsaleHome',

  data() {
    return {
      changeDisabled:false

    }
  },

  mounted() {
   // this.sysNotice()
  },

  methods: {
    /** 
     * Function    : goToRegistrationStep1
     * Description : 신규 신청서 작성
     **/
    goToRegistrationStep1() {
      this.$router.push({ name: 'OnsaleHomeStep1' , params: {isExist : false}})
    },

    /** 
     * Function    : goToExistingRegistration
     * Description : 진행중인 신청서
     **/
    goToExistingRegistration() {
      this.$router.push({ name: 'OnsaleHomeStep1' , params: {isExist : true}})
    },
     /**
     * Function    : openAlert
     * Description : 기본 alert 호출 함수
     **/
    openAlert(title, message) {
        this.$modal.show('dialog', {
          title: title,
          text: message,
          buttons: [{
            title: '확인',
            class: 'primary-button',
          }]
        })
      },

      /**
       * Function    : notice
       * Description : 시스템공지
       **/
      sysNotice() {
        this.changeDisabled = true
        let  title="시스템작업안내"
        let  message = "시스템 점검으로 인하여 일정시간동안 가입신청 이용이 제한됩니다.\n 이용에 불편을 드려 죄송합니다."
        this.openAlert(title, message);
      },

  }
}
</script>

<style scoped>
.btn03 {
  overflow: hidden;
  margin-top: 38px;
}
.btn03 li {
  display: inline-block;
  width: 100%;
}
.btn03 li:nth-child(1) {
  float: left;
}
.btn03 li:nth-child(2) {
  float: right;
}
.btn03 li a {
  display: block;
  border-radius: 3px;
  width: 100%;
  height: 55px;
  line-height: 55px;
  text-align: center;
  font-size: 16px;
}
.btn03 li a.typ01 {
  background: #fff;
  color: #5b5b5b;
  border: 1px solid #d6d6d6;
  box-sizing: border-box;
}
.btn03 li a.typ02 {
  background: #e50689;
  color: #fff;
}
.btn03 li a.typ03 {
  background: #fff;
  color: #e50689;
  border: 1px solid #e50689;
  box-sizing: border-box;
}
.in-progress-registration {
    background: #fff;
    color: #333;
    border: 1px solid #ddd;
}


.input-font {
  font-size: 16px;
  font-weight: 400;
  color: #333333;
  width: 100%;
}
.m-input-half button,
.m-input-half select,
.m-input-half .m-input-half-sub {
  width: 20%;
  margin-left: 0px;
}

.m-input-half .input-text,
.m-input-half .input-font {
  width: calc(80% - 12px);
}
.field-control {
  max-width: 2048px;
  width: 100%;
  font-size: 14px;
  font-weight: 400;
  color: #666666;
  text-align: center;
}

.section-header {
  width: 100%;
  padding: 0 0 18px;
  font-size: 20px;
  font-weight: 400;
  color: #000;
  text-align: center;
  vertical-align: middle;
  border-bottom: 1px solid #ddd;
  position: relative;
}
li.notice-text:before {
  content: '';
  display: block;
  line-height: 1.4;
  position: absolute;
  top: 0;
  left: 0;
}
li.notice-text {
  font-size: 14px;
  font-weight: 400;
  color: #666666;
  line-height: 1.4;
  position: relative;
  padding-left: 14px;
  margin-top: 4px;
  text-align: left;
  word-break: keep-all;
}
.btn_typ01 {
  display: block;
  background: #e50689;
  border-radius: 5px;
  height: 55px;
  line-height: 55px;
  text-align: center;
  color: #fff;
  font-size: 16px;
}
</style>
